import { convertCollectionSuggestions } from '@core/converters'
import { type TCollectionSuggestions } from '@core/models'

import { useCollectionScreenLoaderData } from './useCollectionScreenLoaderData'

/**
 * No fallback on purpose: `CollectionPageDto::$suggestions` defaults to `{ author: [], others: [] }` and
 * the provider degrades a failed lookup to that rather than dropping the key, so the field is as
 * guaranteed as `collection` itself.
 */
export const useCollectionScreenSuggestions = (): TCollectionSuggestions => {
    const { suggestions } = useCollectionScreenLoaderData()

    return convertCollectionSuggestions(suggestions)
}
